import { AnswerT } from '../types/definitions/answer'
import { Question } from '../types/definitions/question'
import { QuestionTypeEnum } from '../types/enums/question-type.enum'

export const shouldTreatAutoCalculatedScoreAsOptional = (
  question: Question | undefined,
  topicQuestions: Question[] = [],
  indexedAnswers: Record<string, AnswerT> = {}
): boolean => {
  if (!question?.required || question.type !== QuestionTypeEnum.NUMERIC) {
    return false
  }

  const scaleQuestions = topicQuestions.filter(({ type }) => type === QuestionTypeEnum.SCALE)

  if (!scaleQuestions.length) {
    return false
  }

  // The NUMERIC score is auto-calculated from scale questions, so treat it as optional when:
  // - All scale questions are skipped (score can't be calculated but shouldn't block completion)
  // - Any scale question has an answer (score will be auto-calculated from those answers)
  const allSkipped = scaleQuestions.every(scaleQuestion => Boolean(indexedAnswers[scaleQuestion.id]?.skipped))
  const anyAnswered = scaleQuestions.some(scaleQuestion => {
    const answer = indexedAnswers[scaleQuestion.id]
    return answer?.answer !== undefined && answer?.answer !== '' && !answer?.skipped
  })
  return allSkipped || anyAnswered
}
